module.exports = __webpack_public_path__ + "src/img/artist/artist05.jpg?81201e629de5e33a5b7d4123d0aa78c1";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist05.jpg
// module id = 112
// module chunks = 0